import LaptopInspectionFieldsContainer from './InspectionFieldsContainer/LaptopInspectionFieldsContainer';
import MonitorInspectionFieldsContainer from './InspectionFieldsContainer/MonitorInspectionFieldsContainer';
import {
  IInitialFieldConfig,
  INSPECTION_CATEGORY,
  TToolInspectionParsedValue
} from 'constants/toolInspection.constants';
import { IInspectionCategory } from 'types/suscription/toolInspection.types';

import './InspectionFieldsSection.scss';

interface IInspectionFieldsSectionProps {
  category: IInspectionCategory | null;
  formFields?: Record<number, IInitialFieldConfig>;
  onFieldChange: (id: number, value: TToolInspectionParsedValue) => void;
  isDisabled?: boolean;
}

const InspectionFieldsSection = ({
  category,
  formFields = [],
  onFieldChange,
  isDisabled = false
}: IInspectionFieldsSectionProps) => {
  const renderInspectionCategoryContent = () => {
    if (!formFields) return null;

    switch (category?.name) {
      case INSPECTION_CATEGORY.Laptops:
      case INSPECTION_CATEGORY.LaptopsDEP:
      case INSPECTION_CATEGORY.LaptopsCTO:
        return (
          <LaptopInspectionFieldsContainer
            fields={formFields}
            setFieldIndividual={onFieldChange}
            isDisabled={isDisabled}
          />
        );

      case INSPECTION_CATEGORY.Monitors:
        return (
          <MonitorInspectionFieldsContainer
            fields={formFields}
            setFieldIndividual={onFieldChange}
            isDisabled={isDisabled}
          />
        );

      default:
        return null;
    }
  };

  return <div className="inspectionFieldsSectionRoot">{renderInspectionCategoryContent()}</div>;
};

export default InspectionFieldsSection;
